module.exports = __webpack_public_path__ + "static/media/chart-42k-v2@4x.4a91a672.png";